/**
 * Formato y parseo de montos del Préstamo de Cercanía.
 * No usar formatCurrency global: ese helper tiene 2 decimales
 * y se comparte con otros módulos.
 */

function formatGroupedInteger(amount) {
  const num = Number(amount);
  if (!Number.isFinite(num)) return '';
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(num));
}

/** Formato de input/slider: $9,100 */
export function formatDigitalLoanAmount(amount) {
  if (amount === '' || amount == null) return '';
  const grouped = formatGroupedInteger(amount);
  if (!grouped) return '';
  return `$${grouped}`;
}

/** Formato de resumen: $ 9,100 MXN */
export function formatDigitalLoanMoney(amount, emptyValue = '$ 0 MXN') {
  if (amount === '' || amount == null) return emptyValue;
  const grouped = formatGroupedInteger(amount);
  if (!grouped) return emptyValue;
  return `$ ${grouped} MXN`;
}

/**
 * Parsea input monetario a pesos enteros.
 * Ignora decimales residuales del formato anterior.
 */
export function parseMoneyInput(raw) {
  const cleaned = String(raw || '').replace(/[^\d.]/g, '');
  if (!cleaned) return '';
  const integerPart = cleaned.split('.')[0];
  if (!integerPart) return '';
  return Number(integerPart);
}

/** Alias de formatDigitalLoanAmount para el input de Valor estimado. */
export function formatMoneyInput(amount) {
  return formatDigitalLoanAmount(amount);
}
